module.exports = __webpack_public_path__ + "img/mobile_icon.8cb12650.svg";